// import { BaseScript } from "../../BaseScript";
// import Index from "../../Index";

import { RichHelper } from "./RichHelper";
import Sprite = Laya.Sprite;
import SpriteUtils = Laya.SpriteUtils;
import Render = Laya.Render;
import Browser = Laya.Browser;
const { regClass, property } = Laya;

@regClass('HguRVT-3QgW3GUUXucAD-A')
export class JiBan extends Laya.Script {
    //declare owner : Laya.Sprite3D;
    //declare owner : Laya.Sprite;
    private video: any;
    private div: any;
    @property(String)
    public text: string = "";
    private myChart: { setOption: any };
    private data: any;
    private option: any;
    private sprDiv: Sprite;
    // public pageWidth: number;
    // public pageHeight: number;
    //组件被激活后执行，此时所有节点和组件均已创建完毕，此方法只执行一次
    onAwake(): void {



        this.initEChart();


    }

    public updateYear(year: string): void {
        console.log(year);
        let source = this.data.slice(1).filter(function (d: string[]) {
            return d[4] === year;
        });
        (this.option as any).series[0].data = source;
        (this.option as any).graphic.elements[0].style.text = year;
        this.myChart.setOption(this.option);
    }

    public IdNames: Map<string, string> = new Map<string, string>();

    public async initOption3(): Promise<void> {
        const updateFrequency = 2000;
        const dimension = 0;
        const ColorDict: Record<string, string> = {
            Wind: '#228B22',
            Water: '#1E90FF',
            Fire: '#DC143C',
            Earth: '#D2691E',
            Light: '#FFF8DC',
            Dark: '#4B0082',
            Default: '#A9A9A9'

        };
        let startIndex = 0;

        //var str = await Laya.loader.load('life.json', Laya.Loader.JSON);

        var map = this.data;
        var nodesdata = map.nodes;
        for (let index = 0; index < nodesdata.length; index++) {
            const v: any = nodesdata[index];
            this.IdNames.set(v.id, v.name);
            //v.symbol = "image://data:image/gif;base64,R0lGODlhEAAQAMQAAORHHOVSKudfOulrSOp3WOyDZu6QdvCchPGolfO0o/XBs/fNwfjZ0frl3/zy7////wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAkAABAALAAAAAAQABAAAAVVICSOZGlCQAosJ6mu7fiyZeKqNKToQGDsM8hBADgUXoGAiqhSvp5QAnQKGIgUhwFUYLCVDFCrKUE1lBavAViFIDlTImbKC5Gm2hB0SlBCBMQiB0UjIQA7";
            v.symbol = 'image://' + RichHelper.getIconUrl(v.id);
            v.symbolSize = 50;
            v.draggable = true;
        }
        //data.symbol = 'image://' + RichHelper.getIconUrl(v.data.id);
        // data.symbol = function (v: any) {
        //     return 'image://http://' + RichHelper.getIconUrl(v.data.id);
        // };


        var ids = this.IdNames;
        console.log("loaded");
        var allrichicon = RichHelper.getAllRichIcon();
        this.option = {
            // legend: [
            //     {
            //         type:'scroll',
            //         orient:'vertical',
            //         left: 'left',
            //         top: 'bottom',                    
            //         // selectedMode: 'single',
            //         selectedMode: 'multiple',
            //         // data: map.categories.map(function (a: any) {
            //         //     return a.name;
            //         // })
            //     }
            // ],
            tooltip: {
                show: true,
                formatter: function (v: any) {
                    //console.log(v);
                    if (v.dataType === "node") {
                        //return '<img src="' + RichHelper.getIconUrl(v.data.id) + '"/> id:' + v.data.id + " " + v.data.name;
                        return v.data.name + v.data.id;
                    } else if (v.dataType === "edge") {
                        // return '<img src="' + RichHelper.getIconUrl(v.data.source) + '"/>' + "->" + '<img src="' + RichHelper.getIconUrl(v.data.target) + '"/>';
                        return ids.get(v.data.source) + "->" + ids.get(v.data.target) + "<br/> " + v.data.text;

                    }

                },
            },

            // dataset: {
            //     source: data.slice(1).filter(function (d: string[]) {
            //         return d[4] === startYear;
            //     })
            // },

            series: [
                {
                    name: "Relation Graph",
                    type: 'graph',
                    layout: 'none',
                    zoom: 1.1,       
                    center: ['49%', '49%'],
                    // data: nodesdata,
                    // links: map.links,
                    // categories: map.categories,
             
                    // roam: true,
                    // focusNodeAdjacency: true,
                    // nodeScaleRatio: 0.6,
                    // draggable: true,
                    // layout: {
                    //     type: 'force',
                    data: nodesdata,
                    links: map.links,
                    catagories: map.categories,
                    roam: true,
                    realtimeSort: false,
                    seriesLayoutBy: 'column',
                    // label: {
                    //     show: true,
                    //     precision: 1,
                    //     position: 'bottom',
                    //     valueAnimation: true,
                    //     fontFamily: 'monospace',
                    // },
                    lineStyle: {

                        width: 2,
                        color: "#000",
                        curveness: 0.2
                    },
                    edgeSymbol: ['none', 'arrow'],
                    edgeLabel: {
                        show: true,
                        position: "middle",
                        formatter: function (v: any) {
                            return v.data.text;
                        },
                        color: "source",
                        fontWeight: "bolder",
                        fontSize: 10,
                    },
                    emphasis: {
                        focus: 'adjacency',
                        scale: 1.5,
                        itemStyle: {
                            borderColor: '#F00',
                            borderWidth: 2,
                            shadowBlur: 10,
                            shadowColor: 'rgba(255, 0, 0, 0.8)'
                        },
                        lineStyle: {
                            width: 5,
                            color: '#F00',
                        },
                        label: {
                            show: true,
                            precision: 1,
                            position: 'bottom',
                            valueAnimation: true,
                            fontFamily: 'monospace',
                            fontSize: 24,
                        },
                        edgeLabel: {
                            show: true,
                            formatter: function (v: any) {
                                return v.data.text;
                            },
                            color: "#F00",
                            fontWeight: "bolder",
                            fontSize: 24,
                        },
                    },

                }
            ],
            // Disable init animation.
            animationDuration: 0,
            animationDurationUpdate: updateFrequency,

            animationEasing: 'linear',
            animationEasingUpdate: 'linear',
            graphic: {
                elements: [
                    // {
                    //     type: 'text',
                    //     right: 160,
                    //     bottom: 60,
                    //     style: {
                    //         text: startYear,
                    //         font: 'bolder 80px monospace',
                    //         fill: 'rgba(100, 100, 100, 0.25)'
                    //     },
                    //     z: 100
                    // },
                    {
                        type: 'image',
                        //left: 0,
                        //bottom: 0,
                        style: {
                            image: 'resources/images/ctworldmap.jpg',
                            width: map.mapWidth,
                            height: map.mapHeight,
                            left: 'center',
                            animationDurationUpdate: 0,
                            // top: 'center',
                            //right: 'center',
                            bottom: 'center',
                            //width: '100%',
                            //height: '100%',
                            //left: '50%',
                            //top: '50%',
                        },
                        z: 0
                    }
                ]
            }
        };

        // console.log(option);
        this.myChart.setOption(this.option);
        var that = this;
        // for (let i = startIndex; i < years.length - 1; ++i) {
        //     Laya.stage.timerOnce((i - startIndex) * updateFrequency, that, () => { that.updateYear(years[i + 1]); });
        // }

    }
    public async initEChart(): Promise<void> {
        //laya相关代码
        var str = await Laya.loader.load('resources/relationgraph.json', Laya.Loader.JSON);
        this.data = str.data;
        var map = this.data;
        // 设置画布上的对齐参照物
        this.sprDiv = new Sprite();
        var reference: Sprite = this.sprDiv;
        this.owner.addChild(reference);
        //reference.pos((this.pageWidth - 600) / 2, (this.pageHeight - 400) / 2);
        reference.pos(0, 0);
        reference.size(map.mapWidth, map.mapHeight);
        reference.graphics.drawRect(0, 0, reference.width, reference.height, "#000000");

        this.sprDiv.size(map.mapWidth, map.mapHeight);

        this.div = Laya.Browser.document.createElement("div");
        this.div.style.width = this.sprDiv.width + "px";// "600px";
        this.div.style.height = this.sprDiv.height + "px"; //"600px";
        Laya.Browser.document.body.appendChild(this.div);
        this.myChart = new Laya.Browser.window.echarts.init(this.div);
        await this.initOption3();
        SpriteUtils.fitDOMElementInArea(this.div, reference, 0, 0, reference.width, reference.height);
    }

    //组件被启用后执行，例如节点被添加到舞台后
    //onEnable(): void {}

    //组件被禁用时执行，例如从节点从舞台移除后
    //onDisable(): void {}

    //第一次执行update之前执行，只会执行一次
    //onStart(): void {}

    //手动调用节点销毁时执行
    //onDestroy(): void {}

    //每帧更新时执行，尽量不要在这里写大循环逻辑或者使用getComponent方法
    //onUpdate(): void {}

    //每帧更新时执行，在update之后执行，尽量不要在这里写大循环逻辑或者使用getComponent方法
    //onLateUpdate(): void {}

    //鼠标点击后执行。与交互相关的还有onMouseDown等十多个函数，具体请参阅文档。
    //onMouseClick(): void {}
}